import { render, staticRenderFns } from "./StGetSvg.vue?vue&type=template&id=35790f2d&"
import script from "./StGetSvg.vue?vue&type=script&lang=js&"
export * from "./StGetSvg.vue?vue&type=script&lang=js&"
import style0 from "./StGetSvg.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports